import Layout from "../../../Components/Layout";
import Tickets from "../../../Components/EventMgt/CreateEvent/Tickets/Tickets";
import { useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import CreateEventFormTab from "../../../Components/EventMgt/CreateEvent/CreateEventFormTab";
import { useLocation, useNavigate, useParams } from "react-router-dom";
const TicketsPages = () => {
  const params = useParams();
  const { eventId } = params;
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      eventId === "undefined" ||
      eventId === undefined ||
      eventId === null ||
      !eventId
    ) {
      navigate("/");
      return;
    }
  }, [location || eventId]);

  const eventData = useSelector((state) => state.event);
  const [createTicketRequest, setCreateTicketRequest] = useState(0);
  const topBarButtonHandler = useCallback(() => {
    setCreateTicketRequest((count) => count + 1);
  }, []);
  const hasTickets =
    eventData?.status && (eventData?.data?.ticketType?.length || 0) > 0;

  return (
    <Layout
      Heading="Events Tickets"
      TitleClassName="event-create-title"
      HeadClassName="event-page-head event-create-head event-create-head--split"
      CreateHead
      BackAction="/organizer/MyEvents"
      activeMenuId="create-event"
      ExtraclassName="event-create-panel"
      extraElement={
        hasTickets ? (
          <button
            className="event-tickets-header-btn"
            type="button"
            onClick={topBarButtonHandler}
          >
            Create Tickets
          </button>
        ) : null
      }
    >
      <div className="eventCreationFrom">
        <CreateEventFormTab
          Id="tickets"
          isOnlyTicket={location?.state?.isOnlyTickets ? true : false}
        />
      </div>
      <Tickets
        isOnlyTicket={location?.state?.isOnlyTickets ? true : false}
        createTicketRequest={createTicketRequest}
      />
    </Layout>
  );
};
export default TicketsPages;
